import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  secret: Yup.string().test(
    'required',
    (secret, { parent: { enabled } }) =>
      (enabled && secret && secret.length > 0) || !enabled,
  ),
});
